import * as angular from 'angular';
import { FindACourseTableComponent } from './find-a-course-table.component';

export const FindACourseTableModule = angular
  .module('FindACourseTableModule', [])
  .component('findACourseTableNew', FindACourseTableComponent).name;
